export type FooterNavigationItem = {
  path: string;
  title: string;
};

export type FooterNavigationItems = Array<{
  path?: string;
  parentPath?: string;
  isExternal?: boolean;
  title: string;
  items: FooterNavigationItem[];
}>;

export const footerNavGroups: FooterNavigationItems = [
  {
    path: 'type',
    parentPath: 'boats',
    title: 'Type',
    items: [
      { path: 'sail', title: 'Sail' },
      { path: 'power', title: 'Power' },
    ],
  },
  {
    path: 'hull-type',
    parentPath: 'boats',
    title: 'Hull Type',
    items: [
      { path: 'catamaran', title: 'Catamaran' },
      { path: 'monohull', title: 'Monohull' },
    ],
  },
  {
    title: 'Manufacturers',
    items: [
      // { path: '/day_cruising', title: 'Day Cruising' },
      // { path: '/overnight_cruising', title: 'Overnight Cruising' },
      // { path: '/sailing', title: 'Sailing' },
      // { path: '/watersports', title: 'Watersports' },
    ],
  },
  {
    title: 'About TheBoatDB',
    items: [
      { path: 'how-it-works', title: 'How it works' },
      { path: 'our-story', title: 'Our story' },
      { path: 'careers', title: 'Careers' },
    ],
  },
  {
    title: 'Pricing',
    items: [{ path: 'pricing', title: 'Pricing' }],
  },
  {
    title: 'Legal',
    isExternal: true,
    items: [
      { path: 'terms-of-service', title: 'Terms of Service' },
      { path: 'user-agreement', title: 'User Agreement' },
      { path: 'privacy-policy', title: 'Privacy Policy' },
    ],
  },
];
